var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-news-detail',{staticClass:"pt-news-detail__page",attrs:{"id":_vm.id}})}
var staticRenderFns = []

export { render, staticRenderFns }